module.exports = __webpack_public_path__ + "static/img/bridge-text-1.b96a9a2a.png";